export default class EnvService {
  
  public static getEnvVar(name: string): string {

    if(!process.env[name]) {
      throw new Error(`Environment variable with name ${name} is not defined.`);
    }
    return process.env[name] as string;
  }
  public static getEnvVarsJoined(envVars: Array<string>): string {
    let result = '';
    for(const envVar of envVars) {
      if(!process.env[envVar]) {
        throw new Error(`Environment variable with name ${envVar} is not defined.`);
      }
      result += process.env[envVar] as string
    }
    return result;
  }
  public static hasEnvVar(name: string): boolean {
    return process.env[name] !== null &&
      process.env[name] !== undefined &&
      process.env[name] !== '';
  }
}